'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.init = undefined;

var _marquee = require('marquee3000');

var _marquee2 = _interopRequireDefault(_marquee);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

var ValuePropsTicker = {};

var initMarkquee = function initMarkquee() {
	setTimeout(function () {
		_marquee2.default.init({
			selector: 'marquee-ticker' // define a custom classname
		});
		/***  
  	pauses ticker for non Live themes. Webpack, hot reload, 
  	and dev tools are causing computer to overheat in development
  ***/
		/*** 
  	pauses ticker for Dev: Adrian & Dev: Tim themes
  ***/
		if ([73321939031, 73087418455].some(function (id) {
			return id === Shopify.theme.id;
		})) {
			ValuePropsTicker.pause();
		}
	}, 1000);
};

ValuePropsTicker.init = function () {
	if (document.readyState === "complete") {
		initMarkquee();
	} else {
		window.addEventListener('load', function (event) {
			initMarkquee();
		});
	}
};

ValuePropsTicker.pause = function () {
	if ($('.marquee-ticker.is-init').length) {
		_marquee2.default.pauseAll();
	}
};
ValuePropsTicker.play = function () {
	if ($('.marquee-ticker.is-init').length) {
		_marquee2.default.playAll();
	}
};

ValuePropsTicker.buildHTML = function (product) {

	if (product) {
		if (product.id === 6582389178455) {
			// Gift Card Restage
			return '';
		}
	}

	var tickerItems = ['Hypoallergenic', 'Safe for Sensitive Skin', 'Eco-friendly', 'Vegan', 'Cruelty-free'];

	var promoContent = PromoManager.getPromoContent('tickers');

	if (promoContent && promoContent.items && promoContent.items.length && promoContent.pages.includes(location.pathname)) {
		tickerItems = promoContent.items;
	}

	return '<div class="marquee-ticker" data-speed="' + (window.innerWidth > 768 ? "1" : "0.5") + '">\n\t\t\t\t\t\t<div class="marquee-ticker__copy">\n\t\t\t\t\t\t\t' + tickerItems.map(function (item) {
		return item + ' <span class="marquee-ticker__divider">-</span>';
	}).join('') + '\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>';
};

var init = exports.init = function init() {
	window.ValuePropsTicker = ValuePropsTicker || {};
};